<template>
  <div class="card mgt-30px">
    <header class="header-card">
      <p>
        {{ $t('detailDispositif.infoTech.title.montageDemontage') }}
      </p>
    </header>
    <div class="card-content columns">
      <div class="column is-3">
        <b-field :label="$t('detailDispositif.infoTech.dateMontage')"
                 custom-class="has-text-link">
          <p> {{ dispositifPublicitaire.dateMontage | formatDate }} </p>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailDispositif.infoTech.dateDemontage')"
                 custom-class="has-text-link">
          <p> {{ dispositifPublicitaire.dateDemontage | formatDate }} </p>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailDispositif.infoTech.etat')"
                 custom-class="has-text-link">
          <p> {{ $t(getLibelle(dispositifPublicitaire.etat)) }}</p>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { ALL_ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';

export default {
  name: 'montageDemontage',
  props: {
    dispositifPublicitaire: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getLibelle(etat) {
      return ALL_ETAT_DISPOSITIF_PUBLICITAIRE.find((el) => {
        return el.value === etat;
      }).libelle;
    },
  },
};
</script>
